<template>
  <div>
    <Header title="User Settings" subtitle="Manage Hack the 6ix user settings"/>
    <template v-if="!loading">
      <div :class="$style.items">
        <Card
            title="User Information"
            direction="column"
            color="background"
            background="black"
            spacing="tad"
            as="section"
        >
          <TextComponent color="background" type="paragraph" as="p">
            Name: {{user.firstName + " " + user.lastName}}
          </TextComponent>
          <TextComponent color="background" type="paragraph" as="p">
            Email: {{user.email}}
          </TextComponent>
        </Card>
        <Card
            title="Discord Link"
            direction="column"
            color="background"
            background="black"
            spacing="tad"
            as="section">
          <TextComponent color="background" type="paragraph" as="p">
            Discord Link Status: {{ (user.discord || {}).discordID ? "Linked" : "Unlinked"}}
          </TextComponent>
          <TextComponent color="background" type="paragraph" as="p">
            Discord OAuth2 Link Status: {{ discordOAuthLinkActive ? "Linked" : "Unlinked"}}
          </TextComponent>
          <Stack
            direction="row">
            <Button v-if="discordOAuthLinkActive" :icon="{ left: `unlink` }" @click="removeDiscord">Unlink Discord</Button>
            <Button v-if="!discordOAuthLinkActive" :icon="{ left: `link` }" @click="startDiscordOAuth">Link Discord</Button>
          </Stack>
        </Card>
      </div>

    </template>
    <template v-else>
      Loading...
    </template>
  </div>
</template>

<script>
  import Button from '@hackthe6ix/vue-ui/Button';
  import Input from '@hackthe6ix/vue-ui/Input';
  import TextComponent from '@hackthe6ix/vue-ui/Text/index';
  import ComboBox from '@hackthe6ix/vue-ui/ComboBox';
  import swal from 'sweetalert';
  import Card from '../../../containers/Card';
  import Header from '../../../containers/Header';
  import Stack from "@hackthe6ix/vue-ui/Stack";
  import {
    associateDiscord,
    disassociateDiscord,
    getAPIAuthProvider,
    getAPIBaseURL,
    getDiscordOAuthUrl
  } from "@/utils/api";
  import {getUser} from "@/utils/UserController";

  import 'vue-awesome/icons/link';
  import 'vue-awesome/icons/unlink';
  import queryString from "query-string";

  export default {
    name: 'UserSettings',
    components: {
      TextComponent,
      Header,
      Button,
      Card,
      Input,
      ComboBox,
      Stack
    },
    data() {
      return {
        loading: true,
        user: {},
        link: {
          state: "",
          code: ""
        }
      }
    },
    methods: {
      startDiscordOAuth() {
        getDiscordOAuthUrl(window.location.protocol + "//" + window.location.host + "/userSettings").then((result) => {
          if(result.success) {
            window.location.href = result.data;
          }
          else {
            swal('Error', result.data, 'error');
          }
        })
      },
      removeDiscord() {
        swal({
          title: 'CONFIRM ACTION',
          text: 'Are you sure you disassociate your Discord account? Roles on the Hack the 6ix server will be revoked until you re-link.',
          icon: 'warning',
          buttons: true,
          dangerMode: true,
        }).then(async (confirm) => {
          if (confirm) {
            const result = await disassociateDiscord(this.user._id);

            if (result.success) {
              swal('Success', result.data.toString(), 'success');
            } else {
              swal('Error', result.data, 'error');
            }
          }
        });
      }
    },
    computed: {
      discordOAuthLinkActive() {
        return !!((this.user.discord || {}).refreshToken)
      }
    },
    mounted() {
      if(this.link.code && this.link.state) {
        associateDiscord(this.link.state, this.link.code).then((result) => {
          this.$router.replace({query: null});
          if(result.success) {
            swal('Success', 'Your Discord account has been successfully linked.', 'success');
          }
          else {
            swal('Error', result.data, 'error');
          }
        });
      }
    },
    beforeMount() {
      (async () => {
        const params = queryString.parse(location.search);
        if(params.code && params.state) {
          this.link = {
            code: params.code,
            state: params.state
          }
        }
        this.user = await getUser();
        this.loading = false;
      })();
    },
  };
</script>

<style src="./UserSettings.module.scss" lang="scss" module/>
